import React from "react";
import { useI18n } from "./I18nProvider";

/**
 * Titres de section type « My » (marine) + « Portfolio » (or + souligné dégradé).
 */
export function SectionTitle({ beforeKey, afterKey, className = "" }) {
  const { t } = useI18n();
  const a = t(beforeKey);
  const b = t(afterKey);
  const h1Class = `${className} pro-section-title`.trim();

  if (!a && b) {
    return (
      <h1 className={h1Class}>
        <span className="pro-section-title__accent">{b}</span>
      </h1>
    );
  }

  return (
    <h1 className={h1Class}>
      <span className="pro-section-title__muted">{a}</span>{" "}
      <span className="pro-section-title__accent">{b}</span>
    </h1>
  );
}
